import React from 'react';
import StarRatings from 'react-star-ratings';

const StaticStarUI = ({ rating, ...props }) => {
  return <StarRatings rating={rating} starRatedColor="#ffc110" numberOfStars={5} name="rating" starDimension="25px" starSpacing="1px" />;
};

export default StaticStarUI;
